import Conclave from '../components/conclave';

export default function Skillconclave() {
  return(
    <Conclave geturl={'https://cpccbe.org/api/skillconclave/allmodals'} 
    createmodel1url={'https://cpccbe.org/api/skillconclave/modal1'}
    createmodel2url={'https://cpccbe.org/api/skillconclave/modal2'}
    updateurl={'https://cpccbe.org/api/skillconclave/modal'}
    deleteurl={'https://cpccbe.org/api/skillconclave/modal'}
    head={'Skill Conclave'}
    />
  );
}